import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { generateReportSummary } from "../../../api/propertiesApi";

const CustomContentDialog = ({ visible, onHide, properties, initialUserPrompt, initialCustomContent, onSave }) => {
  const [localUserPrompt, setLocalUserPrompt] = useState(initialUserPrompt || '');
  const [localCustomContent, setLocalCustomContent] = useState(initialCustomContent || '');
  const [selectedAiOption, setSelectedAiOption] = useState('auto');
  const [isLoading, setIsLoading] = useState(false);

  const aiOptions = [
    { label: 'Generar automáticamente', value: 'auto' },
    { label: 'Editar manualmente', value: 'manual' }
  ];

  useEffect(() => {
    if (visible) {
      setLocalUserPrompt(initialUserPrompt || '');
      setLocalCustomContent(initialCustomContent || '');
    }
  }, [visible, initialUserPrompt, initialCustomContent]);

  const handleSave = () => {
    onSave(localUserPrompt, localCustomContent);
    onHide();
  };

  return (
    <Dialog 
      header="Editar Contenido Personalizado" 
      visible={visible} 
      style={{ width: '90vw', height: '90vh' }}
      onHide={onHide}
    >
      <div className="p-fluid">
        {isLoading && (
          <div className="loading-overlay">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
            <p>Generando contenido...</p>
          </div>
        )}
        <div className="p-grid">
          <div className="p-col-12 p-md-3">
            <div className="p-field">
              <label>Tipo de contenido:</label>
              <Dropdown
                options={aiOptions}
                value={selectedAiOption}
                onChange={(e) => setSelectedAiOption(e.value)}
                placeholder="Seleccionar tipo"
              />
            </div>

            {selectedAiOption === 'auto' && (
              <div className="p-field">
                <label>Instrucciones para la IA:</label>
                <InputTextarea
                  value={localUserPrompt}
                  onChange={(e) => setLocalUserPrompt(e.target.value)}
                  placeholder="Ej: Destacar los 3 mejores valores por m²..."
                  rows={5}
                  cols={30}
                  style={{ width: '100%' }}
                />
                <Button
                  label="Generar"
                  style={{ marginBottom: '20px' }}
                  className="details-button"
                  onClick={async () => {
                    setIsLoading(true);
                    try {
                      const requestData = { properties: properties || [], user_prompt: localUserPrompt || "" };
                      const response = await generateReportSummary(requestData.properties, requestData.user_prompt);
                      setLocalCustomContent(response.summary);
                    } catch (error) {
                      console.error("Error al generar el informe:", error.message);
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                />
              </div>
            )}
          </div>

          <div className="p-col-12 p-md-9">
            <InputTextarea
              id="customContentEditor"
              value={localCustomContent}
              onChange={(e) => setLocalCustomContent(e.target.value)}
              rows={15}
              style={{ width: '100%', minHeight: '400px' }}
            />
          </div>
        </div>

        <div className="p-d-flex p-jc-between p-mt-3">
          <Button
            label="Cancelar"            
            className="details-button"
            onClick={onHide}
          />
          <Button
            label="Guardar"            
            className="details-button"
            onClick={handleSave}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CustomContentDialog;